import { Button, Form, Input, Space } from 'antd';
import React from 'react'
import GetDept from '../../cpn/GetDept';
import GetGoodsType from './GetGoodsType';

function GoodsQuery(props) {    
    const [form] = Form.useForm();  
    return (
        <Form
            form={form}
            layout="inline"
            name="form_in_modal"
            initialValues={{
                modifier: 'public',
                eg_name:'',
                eg_dept_id:'',
                eg_egt_id:"",
            }}
            labelCol={{ span: 7 }}
            onFinish={() => {
                form
                .validateFields()
                .then((values) => {
                    props.getGoodsQuery(values);
                })
                .catch((info) => {
                    console.log('Validate Failed:', info);
                });
            }}
        >
            <GetDept 
                label='部门' 
                getDept={(e) => {}} 
                style={{width:"200px"}}
                name='eg_dept_id'
            />
            <GetGoodsType 
                label='产品类型' 
                wrapperCol={{span:20}} 
                style={{width:"200px"}}
                getGoodsType={(e) => {
                }}
                name='eg_egt_id'
            />
            <Form.Item name="eg_name" label='产品名称' wrapperCol={{span:15}}>
                <Input 
                    onChange={(e) => {}}
                />
            </Form.Item> 
            <Form.Item>
                <Space>
                    <Button
                        htmlType='submit'
                    >
                        查询
                    </Button>
                <Button onClick={() => {                                        
                    form.resetFields();
                    props.getGoodsQuery({
                        eg_name:'',
                        eg_dept_id:'',
                        eg_egt_id:""
                    })
                    }}>重置</Button>
                </Space>
            </Form.Item>                               
        </Form>
    )
}

export default GoodsQuery